// Helper to create slug
const createSlug = (text) => text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');

export const puzzles = [
  {
    date: "2026-01-04",
    title: "Daily Mini #1",
    clues: {
      across: [
        {
          id: "1a",
          number: 1,
          direction: "across",
          text: "Not loud",
          slug: "not-loud",
          answer: "QUIET",
          hint_1: "Silent or hushed; making little noise.",
          hint_2: "T U I E Q",
          hint_3: "Opposite of loud.",
        },
        {
          id: "4a",
          number: 4,
          direction: "across",
          text: "Fruit that keeps the doctor away",
          slug: "fruit-that-keeps-the-doctor-away",
          answer: "APPLE",
          hint_1: "A round, edible fruit that is typically red or green.",
          hint_2: "P P L E A",
          hint_3: "Commonly associated with teachers and doctors.",
        },
        {
          id: "5a",
          number: 5,
          direction: "across",
          text: "Celestial body",
          slug: "celestial-body",
          answer: "STAR",
          hint_1: "A luminous point in the night sky.",
          hint_2: "R A T S",
          hint_3: "The Sun is one of these.",
        },
      ],
      down: [
        {
          id: "1d",
          number: 1,
          direction: "down",
          text: "Middle East nation",
          slug: "middle-east-nation",
          answer: "QATAR",
          hint_1: "A peninsular Arab country.",
          hint_2: "R A T A Q",
          hint_3: "Hosted the 2022 FIFA World Cup.",
        },
        {
          id: "2d",
          number: 2,
          direction: "down",
          text: "Top of a house",
          slug: "top-of-a-house",
          answer: "UPPER",
          hint_1: "Higher in place or position.",
          hint_2: "P P E R U",
          hint_3: "The opposite of lower.",
        },
        {
          id: "3d",
          number: 3,
          direction: "down",
          text: "Small island",
          slug: "small-island",
          answer: "ISLE",
          hint_1: "A distinct piece of land surrounded by water.",
          hint_2: "L E S I",
          hint_3: "Homophone for 'aisle'.",
        },
      ],
    },
  },
  {
    date: "2026-01-03",
    title: "Daily Mini #0",
    clues: {
      across: [
        {
          id: "1a",
          number: 1,
          direction: "across",
          text: "Feline pet",
          slug: "feline-pet",
          answer: "CAT",
          hint_1: "A small domesticated carnivorous mammal.",
          hint_2: "T C A",
          hint_3: "Says meow.",
        },
      ],
      down: [
        {
          id: "1d",
          number: 1,
          direction: "down",
          text: "Vehicle",
          slug: "vehicle",
          answer: "CAR",
          hint_1: "A road vehicle, typically with four wheels.",
          hint_2: "R A C",
          hint_3: "You drive it.",
        },
      ],
    },
  },
  {
    date: "2026-01-02",
    title: "Daily Mini #-1",
    clues: {
      across: [
        {
          id: "1a",
          number: 1,
          direction: "across",
          text: "Hot beverage",
          slug: "hot-beverage",
          answer: "TEA",
          hint_1: "A hot drink made by infusing dried leaves.",
          hint_2: "E A T",
          hint_3: "British favorite.",
        },
      ],
      down: [
        {
          id: "1d",
          number: 1,
          direction: "down",
          text: "Number",
          slug: "number",
          answer: "TEN",
          hint_1: "The number after nine.",
          hint_2: "N E T",
          hint_3: "A decade.",
        },
      ],
    },
  },
    {
    date: "2026-01-01",
    title: "Daily Mini #-2",
    clues: {
      across: [
        {
          id: "1a",
          number: 1,
          direction: "across",
          text: "Hot beverage",
          slug: "hot-beverage",
          answer: "TEA",
          hint_1: "A hot drink made by infusing dried leaves.",
          hint_2: "E A T",
          hint_3: "British favorite.",
        },
      ],
      down: [
        {
          id: "1d",
          number: 1,
          direction: "down",
          text: "Number",
          slug: "number",
          answer: "TEN",
          hint_1: "The number after nine.",
          hint_2: "N E T",
          hint_3: "A decade.",
        },
      ],
    },
  },
];
